import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiClinngButtonComponent } from '../ui-clinng-button/ui-clinng-button.component';

interface Data {
  onBack?: () => void;
}

@Component({
  selector: 'ui-clinng-pending-alert',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    UiClinngButtonComponent
  ],
  templateUrl: './ui-clinng-pending-alert.component.html',
  styleUrl: './ui-clinng-pending-alert.component.scss',
})
export class UiClinngPendingAlertComponent {
  title: string = 'Operación inválida';
  subtitle1: string = 'Recuerda que debes aceptar la operación en tu App Nequi.';
  subtitle2: string = 'Por favor, realiza esta solicitud nuevamente.';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private dialogRef: MatDialogRef<UiClinngPendingAlertComponent>
  ) {}

  handleBack(): void {
    if (this.data?.onBack) {
      this.data.onBack();
    }
    this.dialogRef.close();
  }
}

